import React from 'react'
import FeedSearchDetails from './feed-search-details'
import Layout from '../layout'
import { useSx } from 'dripsy';

const FeedSearch = () => {
  const sx = useSx();
  return (
    <Layout subContainerStyle={sx({ maxWidth: ['100%', 1248] })}>
      <FeedSearchDetails></FeedSearchDetails>
    </Layout>
  )
}

export default FeedSearch
